import { render, staticRenderFns } from "./linkMan.vue?vue&type=template&id=25ff066c&scoped=true&"
import script from "./linkMan.vue?vue&type=script&lang=js&"
export * from "./linkMan.vue?vue&type=script&lang=js&"
import style0 from "./linkMan.vue?vue&type=style&index=0&id=25ff066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff066c",
  null
  
)

export default component.exports